import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Text } from 'components/common/ui';
import { PermissionsGate, CertifiedIcon } from '@components';
import { ENTITIES_PERMISIONS } from 'components/common/PermissionsGate/constants';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ContactsIcon from '@mui/icons-material/Contacts';
import styles from './servicePointSidebar.styles';
import { ServicePointContactsModal } from '../ServicePointContactsModal/ServicePointContactsModal';
import { AddServicePointAddressModal } from '../AddServicePointAddressModal/AddServicePointAddressModal';
import { EditableField } from './EditableField';
import { ContactList } from './ContactList';

export const ServicePointSidebar = ({
  servicePoint,
  getServicePoint,
  loading,
  addressData,
  editField,
  enums,
}) => {
  const [contactModalOpen, setContactModalOpen] = useState(false);

  const allContacts = servicePoint?.contacts || [];

  if (!servicePoint) {
    return null;
  }
  const handleCloseContactModal = () => {
    setContactModalOpen(false);
  };

  const matchEnum = (prop, text) => {
    const match = enums[prop]
      ?.filter((v) => {
        return v.id === text;
      })
      .pop();

    return match?.name;
  };
  return (
    <>
      <Box sx={styles.asidePanel}>
        <Box sx={styles.asideContainer}>
          <Box sx={styles.sectionHeader}>
            <Box sx={styles.sectionHeaderContent}>
              <LocationOnOutlinedIcon sx={{ fontSize: '22px' }} />
              <Typography variant="h6" sx={styles.sectionTitle}>
                Service Point
              </Typography>
            </Box>
          </Box>

          <Box sx={styles.contentContainer}>
            <Box>
              <Typography sx={styles.fieldLabel}>Service point ID:</Typography>
              <Text loading={loading} sx={styles.fieldValue}>
                {servicePoint?.internalId?.value}
              </Text>
            </Box>

            <Box>
              <Typography sx={styles.fieldLabel}>Slug:</Typography>
              <Text loading={loading} sx={styles.fieldValue}>
                {servicePoint?.slug?.value || servicePoint?.slug || '-'}
              </Text>
            </Box>

            <Box>
              <Typography sx={styles.fieldLabel}>
                Service Point Name:
              </Typography>
              <Box sx={styles.fieldLabelWithIcon}>
                <Text loading={loading} sx={styles.fieldValue}>
                  {servicePoint?.name?.value || '-'}
                </Text>
                {servicePoint?.isCertified && <CertifiedIcon />}
              </Box>
            </Box>

            <Box>
              <Typography sx={styles.fieldLabel}>Address:</Typography>
              <Box sx={styles.addressContainer}>
                {addressData?.name ? (
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${addressData?.lat},${addressData?.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.addressLink}
                  >
                    <Text
                      loading={loading}
                      variant="span"
                      sx={styles.addressText}
                    >
                      {addressData?.name}
                    </Text>
                  </a>
                ) : (
                  <Text loading={loading} sx={styles.fieldValue}>
                    -
                  </Text>
                )}
                <PermissionsGate
                  entity={ENTITIES_PERMISIONS.WriteServicePoints}
                >
                  <AddServicePointAddressModal
                    servicePoint={servicePoint}
                    getServicePoint={getServicePoint}
                    iconOnly
                  />
                </PermissionsGate>
              </Box>
            </Box>

            <EditableField
              label="Bank:"
              value={matchEnum(
                'supportedBanks',
                servicePoint?.supportedBanks?.value
              )}
              loading={loading}
              onEdit={editField}
              field={servicePoint?.supportedBanks}
            />

            <EditableField
              label="IBAN:"
              value={servicePoint?.bankIban?.value}
              loading={loading}
              onEdit={editField}
              field={servicePoint?.bankIban}
              showEdit={!loading}
            />

            <Box>
              <Typography sx={styles.fieldLabel}>Created at:</Typography>
              <Text loading={loading} sx={styles.fieldValue}>
                {servicePoint?.createdAt?.value || '-'}
              </Text>
            </Box>
            <Box>
              <Typography sx={styles.fieldLabel}>Updated at:</Typography>
              <Text loading={loading} sx={styles.fieldValue}>
                {servicePoint?.updatedAt?.value || '-'}
              </Text>
            </Box>
          </Box>

          <Box sx={styles.divider} />

          <Box sx={styles.contactSectionHeader}>
            <Box sx={styles.sectionHeaderContent}>
              <ContactsIcon
                sx={{
                  fontSize: '16px',
                }}
              />
              <Typography variant="h6" sx={styles.contactSectionTitle}>
                Contact&apos;s Details
              </Typography>
            </Box>
          </Box>

          <Box sx={styles.contactContent}>
            <ContactList
              label="Contact Person:"
              contacts={allContacts}
              loading={loading}
              type="person"
            />

            <ContactList
              label="Phone:"
              contacts={allContacts}
              loading={loading}
              type="phone"
            />

            <ContactList
              label="Email:"
              contacts={allContacts}
              loading={loading}
              type="email"
            />
          </Box>
        </Box>
      </Box>

      <ServicePointContactsModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        contacts={allContacts}
        loading={loading}
      />
    </>
  );
};
